import React from 'react';
import styled, { css } from 'styled-components';
import { device } from '@styles/mediaQuery';

type ArticleDescriptionProps = {
  align?: 'left' | 'right' | 'center';
  descriptionMaxWidth?: string;
  description: string;
  margin?: string;
  fontSize?: string;
  fontSizeL?: string;
};

function ArticleDescription({
  descriptionMaxWidth,
  description,
  fontSizeL,
  fontSize,
  margin,
  align,
}: ArticleDescriptionProps) {
  return (
    <StyledParagraph
      $align={align}
      $width={descriptionMaxWidth}
      $fontSize={fontSize}
      $fontSizeL={fontSizeL}
      $margin={margin}
    >
      {description}
    </StyledParagraph>
  );
}

const StyledParagraph = styled.p<{
  $width?: string;
  $align?: string;
  $margin?: string;
  $fontSize?: string;
  $fontSizeL?: string;
}>`
  font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : '14px')};
  line-height: 20px;
  text-align: ${({ $align }) => $align};
  max-width: ${({ $width }) => $width};
  margin: ${({ $margin }) => $margin};
  color: ${({ theme }) => theme.colors.textSecondary};

  ${device.tablet(css<{ $fontSizeL?: string }>`
    font-size: ${({ $fontSizeL }) => ($fontSizeL ? $fontSizeL : '18px')};
    line-height: 25px;
  `)}
`;

export default ArticleDescription;
